export default {
  header: {
    title: ['Order a', 'ride', 'with a worldwide platform'],
    subTitle: 'Using streaming mobility platform',
  },
  scrollText:
    'Nous désirons vous rappeler que la gratuité offerte à bord des lignes exo Terrebonne-Mascouche T6, T12, T13, T15, T24, T26, T417, T55, T56, T57 prend fin le 31 août. Plus d’info : exo.quebec/avis',
  exoNote: 'À partir du 30 juin 2ham, Taxelco n\'offrira plus le service de transport collectif pour EXO, pour commander un transport, composer le 514-285-5284 ou rendez-vous sur exo.quebec/taxicollectif',
  btnLinkText: 'MESSAGE IMPORTANT AUX USAGERS, CLIQUEZ ICI',
};
